import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { FixFlipStore } from '../stores';

export const useFixFlipStore = () => useContext<{
  fixFlipStore: FixFlipStore
}>(StoreContext);
